<h1 class="_home-page-content-tab-label">
  Order Now For Delivery
</h1>

<mat-form-field class="_home-page-content-tab-form">
  <input class="_home-page-content-tab-form-input"
         matInput
         id="postCodeInput"
         [formControl]="postcodeFormControl"
         placeholder="Enter your postcode to begin"
         maxlength="10"
         autocomplete="off"
         (keyup.enter)="validatePostCode()"
         #PostCodeInput>
</mat-form-field>

<p class="_home-page-content-tab-error" *ngIf="errorPostCode">Please enter a valid postcode.</p>

<div class="stores-default-container" *ngIf="searchPerformed && noStoresFound">
  <div class="stores-default-Item-body" *ngIf="shouldRedirect">
    Redirecting <div class="lds-dual-ring"></div>
  </div>
  <div class="stores-default-Item-body" *ngIf="!shouldRedirect">
    Sorry - we don't deliver to your postcode
  </div>
</div>

@if (!foundStores || foundStores.length <= 1) {
  <button class="_home-page-content-tab-button button-action-1"
          (click)="inputPostCode()"
          [class.button-action-disabled]="disableOrderButton"
          [disabled]="disableOrderButton">
    <div class="_home-page-content-tab-button-text">Order Now</div>
    <span class="material-symbols-outlined"> arrow_right_alt </span>
  </button>
}

<div class="_home-page-content-tab-hasSites" style="display: flex; align-items: center; justify-content:center" *ngIf="loadingStores">
  <div class="lds-dual-ring"></div>
</div>

<div class="_home-page-content-tab-hasSites" *ngIf="!noStoresFound && searchPerformed && !errorPostCode && foundStores?.length > 1">
  <div class="_home-page-content-tab-hasSites-label">
    <mat-icon class="_home-page-content-tab-store-item-icon">store</mat-icon>
    Available Stores
  </div>
  <app-home-page-store-dropdown [stores]="foundStores" [occasion]="occasion" (onSelection)="setSelectedStore($event)"></app-home-page-store-dropdown>
</div>
